import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-historique-competence',
  templateUrl: './historique-competence.component.html',
  styleUrls: ['./historique-competence.component.css']
})
export class HistoriqueCompetenceComponent implements OnInit {
  @Input() COMPETENCES: any;
  public response: any[]
  constructor() { }

  ngOnInit() {
    setTimeout(() => {
      this.GetCompetence()
    }, 500);
  }

  public GetCompetence(): void {
    this.response = this.COMPETENCES;
  }
}
